import angular from 'angular';

import { ResponsiveController } from './controllers/responsiveController';
import { ResponsiveService } from './services/responsive.service';

export const PageModule = angular
    .module('oo.common.page', [])
    .controller('responsiveController', ResponsiveController)
    .service('ResponsiveService', ResponsiveService)
    .name;
